import { useTranslate } from "@similarweb/i18n-provider";
import { Tooltip } from "@similarweb/ui-components";

import { ONBOARDING_AGENT_FEEDBACK_THUMBS_UP } from "../texts";

import { ReplyFeedbackIconButton } from "./styles";
import { useOnboardingAgentThumbsUpFeedback } from "./hooks/useOnboardingAgentThumbsUpFeedback";

type OnboardingAgentReplyThumbsUpButtonProps = {
    messageIndex: number;
    isActive: boolean;
    threadId?: string;
    onActiveChange: (active: boolean) => void;
    onClearDislike: () => void;
    dataAutomation: string;
};

export const OnboardingAgentReplyThumbsUpButton = ({
    messageIndex,
    isActive,
    threadId,
    onActiveChange,
    onClearDislike,
    dataAutomation,
}: OnboardingAgentReplyThumbsUpButtonProps) => {
    const { translate } = useTranslate();
    const { handleClick } = useOnboardingAgentThumbsUpFeedback({
        messageIndex,
        isActive,
        threadId,
        onActiveChange,
        onClearDislike,
    });

    return (
        <Tooltip
            content={translate(ONBOARDING_AGENT_FEEDBACK_THUMBS_UP)}
            placement="bottom"
        >
            <ReplyFeedbackIconButton
                type="flat"
                iconName={isActive ? "thumb-up" : "thumb-up-outline"}
                iconSize="xs"
                dataAutomation={dataAutomation}
                onClick={handleClick}
            />
        </Tooltip>
    );
};
